import encryptText from './encryptText';

// The dynamic-form module wants just the mask; encryptText also round-trips a
// decrypt that no caller here consumes.
export default function passwordMask(value) {
  return encryptText(value)[0];
}
